import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

const ImpersonatePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setError('Missing token');
      setTimeout(() => navigate('/login', { replace: true }), 2000);
      return;
    }

    const doImpersonate = async () => {
      try {
        // Clear any existing session first
        await supabase.auth.signOut();

        // Verify the OTP token to establish a new session
        const { data, error: verifyError } = await supabase.auth.verifyOtp({
          token_hash: token,
          type: 'magiclink',
        });

        if (verifyError) {
          console.error('Verify OTP error:', verifyError);
          setError('Login failed: ' + verifyError.message);
          setTimeout(() => navigate('/login', { replace: true }), 3000);
          return;
        }

        // Success - redirect to profile
        navigate('/my-profile', { replace: true });
      } catch (err) {
        console.error('Impersonate error:', err);
        setError('Login failed: ' + err.message);
        setTimeout(() => navigate('/login', { replace: true }), 3000);
      }
    };

    doImpersonate();
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        {error ? (
          <p className="text-red-600 mb-2">{error}</p>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
            <p className="text-gray-600 dark:text-gray-400">Signing in as user...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default ImpersonatePage;
